import { useEffect, useState } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

function UseOfPropertyDropdown(propertyTypeId: any, propertyDescriptioTypeId: any) {
  const [useOfProperty, setUseOfProperty] = useState<any>([]);
  const [loadingUseOfProperty, setLoadingUseOfProperty] = useState(false);
  const [isDropdownOpenUseOfProperty, setIsDropdownOpenUseOfProperty] = useState(false);

  const fetchPropertyTypes = async () => {
    if (loadingUseOfProperty) return;

    setLoadingUseOfProperty(true);

    try {
      const response = await axiosInstance.post(`${API_URLS.TypeDescriptionWiseUseOfProperty}`,
        {
          property_type_id: propertyTypeId,
          property_description_id: propertyDescriptioTypeId
        }
      );

      if (response.data.data.rows) {
        setUseOfProperty(response.data.data.rows);
      }
    } catch (error) {
      console.error("Error fetching property descriptions", error);
    } finally {
      setLoadingUseOfProperty(false);
    }
  };

  useEffect(() => {
    if (propertyTypeId && propertyDescriptioTypeId) {
      fetchPropertyTypes();
    }
  }, [propertyTypeId, propertyDescriptioTypeId]);

  return [
    setIsDropdownOpenUseOfProperty,
    isDropdownOpenUseOfProperty,
    fetchPropertyTypes,
    useOfProperty,
    loadingUseOfProperty
  ];
}

export default UseOfPropertyDropdown;